<template>
    <div class="collection-management">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="收款列表" name="1"></el-tab-pane>
            <el-tab-pane label="确认单列表" name="2"></el-tab-pane>
        </el-tabs>
        <div class="tab-content">
            <myColletionOrder v-if="activeTab === '2'" ref="myColletionOrder"></myColletionOrder>
            <totalCollectionOrderList v-else ref="totalCollectionOrderList"></totalCollectionOrderList>
        </div>
    </div>
</template>

<script>
import myColletionOrder from './child/myColletionOrder.vue'
import totalCollectionOrderList from './child/totalCollectionOrderList.vue'

export default {
    name: 'collectionManagement',
    components: { myColletionOrder, totalCollectionOrderList },
    data() {
        return {
            activeTab: '1'
        }
    }
}
</script>

<style lang="scss" scoped>
.collection-management {
}
</style>
